@if (medicine) {
  <mat-card class="medicine-view">
    @if (medicine) {
      <div class="row">
        <div class="col-md-6">
          <mat-card-title>{{medicine.name}}</mat-card-title>
        </div>
        <div class="col-md-6 text-end">
          <button *authGroup="['SuperAdmin']" mat-flat-button color="warn" (click)="delete()" class="me-2">
            Delete
          </button>
          @if (perm.canEditMedicineCatalogue()) {
            <button color="primary" mat-flat-button (click)="editMode = !editMode">
              {{editMode ? 'Details' : 'Edit'}}
            </button>
          }
        </div>
      </div>
    }
    <p class="mt-2">
      <button mat-stroked-button (click)="backToList()" class="me-2">
        <mat-icon>arrow_back</mat-icon> Back to list
      </button>
    </p>
    @if (editMode) {
      <div>
        <form class="mt-3" [formGroup]="medicineForm">
          <div class="row">
            <div class="col-md-6">
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Name</mat-label>
                  <input formControlName="name" type="text" matInput placeholder="Name">
                  @if (medicineForm.get('name')?.invalid) {
                    <mat-error>
                      Name is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Barcode prefix</mat-label>
                  <input formControlName="barcodePrefix" type="text" matInput placeholder="Barcode prefix">
                  @if (medicineForm.get('barcodePrefix')?.invalid) {
                    <mat-error>
                      Barcode prefix is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Active ingredient</mat-label>
                  <input formControlName="activeIngredient" type="text" matInput
                    placeholder="Active ingredient">
                  @if (medicineForm.get('activeIngredient')?.invalid) {
                    <mat-error>
                      Active ingredient is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Active ingredient nappy code</mat-label>
                  <input formControlName="activeIngredientNappyCode" type="text" matInput
                    placeholder="Barcode prefix">
                  @if (medicineForm.get('activeIngredientNappyCode')?.invalid) {
                    <mat-error>
                      Active ingredient nappy code is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>
            </div>
          </div>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Schedule status</mat-label>
              <mat-select formControlName="scheduleStatus">
                @for (status of scheduleStatuses; track status) {
                  <mat-option [value]="status">
                    {{status}}
                  </mat-option>
                }
              </mat-select>
              @if (medicineForm.get('scheduleStatus')?.invalid) {
                <mat-error>
                  Schedule status is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Description</mat-label>
              <textarea formControlName="description" matInput placeholder="Description"></textarea>
              @if (medicineForm.get('description')?.invalid) {
                <mat-error>
                  Description is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-checkbox formControlName="canOrder" color="primary">
              Can be Ordered
            </mat-checkbox>
          </p>
        </form>
        <div class="text-end mt-2">
          <button (click)="save()" mat-raised-button color="primary">
            <mat-icon>save</mat-icon> Save
          </button>
        </div>
      </div>
    }
    @if (!editMode && medicine) {
      <div class="details mt-3">
        <table>
          <tr>
            <th>
              Name
            </th>
            <td>
              {{medicine.name ? medicine.name : '-'}}
            </td>
          </tr>
          <tr>
            <th>
              Description
            </th>
            <td>
              {{medicine.description ? medicine.description : '-'}}
            </td>
          </tr>
          <tr>
            <th>
              Barcode prefix
            </th>
            <td>
              {{medicine.barcode_prefix ? medicine.barcode_prefix : '-'}}
            </td>
          </tr>
          <tr>
            <th>
              Active ingredient
            </th>
            <td>
              {{medicine.active_ingredient ? medicine.active_ingredient : '-'}}
            </td>
          </tr>
          <tr>
            <th>
              Active ingredient nappy code
            </th>
            <td>
              {{medicine.active_ingredient_nappy_code ? medicine.active_ingredient_nappy_code : '-'}}
            </td>
          </tr>
          <tr>
            <th>
              Schedule status
            </th>
            <td>
              {{medicine.schedule_status}}
            </td>
          </tr>
          <tr>
            <th>Order System</th>
            @if (medicine.can_be_ordered !== null) {
              <td>
                <mat-checkbox [checked]="medicine.can_be_ordered" color="primary"></mat-checkbox>
              </td>
            }
          </tr>
          <tr>
            <th>
              Created
            </th>
            <td>
              {{formatTime(medicine.created_at)}}
            </td>
          </tr>
          <tr>
            <th>
              Updated
            </th>
            <td>
              {{formatTime(medicine.updated_at)}}
            </td>
          </tr>
        </table>
      </div>
    }
    <div class="mb-2 mt-3">
      <div class="py-2">
        <mat-divider></mat-divider>
      </div>
      <div class="row my-2">
        <div class="col-md-6">
          <h2>Dosage and package types</h2>
        </div>
        <div class="col-md-6 text-end">
          <button *authGroup="['SuperAdmin']" class="me-2" mat-stroked-button (click)="createMedicineDosageType()">
            <mat-icon>add</mat-icon> Create new
          </button>
          <button mat-stroked-button (click)="refreshMedicineDosageTypes(true)">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
      <core-medicine-dosage-types-list [medicineId]="medicine.id"
        (onMedicineDosageTypeUpdated)="refreshMedicineDosageTypes($event)"
        [medicineDosageTypes]="medicineDosageTypes" [dosageTypes]="dosageTypes" [packageTypes]="packageTypes"
      [dosageUnits]="dosageUnits"></core-medicine-dosage-types-list>
    </div>
  </mat-card>
}